export const enum dashboardConstants{
    getDashboardRequest="GET_DASHBOARD_REQUEST",
    getDashboardSuccess="GET_DASHBOARD_SUCCESS",
    getDashboardFailure="GET_DASHBOARD_FAILURE",
}